import React from "react";
import { EmptyState } from "../design_system/components/EmptyState/EmptyState";
import { Icons } from "../design_system/components/Icons";
import "./teamContext.scss";

export default function TeamLoadError({ onRetry }) {
  return <main className="team-load-error" aria-labelledby="team-load-error-title">
    <div className="team-load-error__content" role="alert">
      <EmptyState
        className="team-load-error__state"
        icon={<span className="team-load-error__icon" aria-hidden="true"><Icons name="refresh" size={24} /></span>}
        title={<h1 id="team-load-error-title" className="headline-l-bold">We couldn’t open your team</h1>}
        description="Please try again in a moment."
        primaryAction={{ label: "Try again", Size: "Medium", onClick: onRetry }}
      />
    </div>
  </main>;
}
